import { commonAuth as enAuth } from "./i18n/features/en/common-auth";
import { platformStatuses as enStatuses } from "./i18n/features/en/platform-statuses";
import { sharedCoreEn } from "./i18n/features/en/shared-core";
import { commonAuth as jaAuth } from "./i18n/features/ja/common-auth";
import { platformStatuses as jaStatuses } from "./i18n/features/ja/platform-statuses";
import { sharedCoreJa } from "./i18n/features/ja/shared-core";
import { commonAuth as zhAuth } from "./i18n/features/zh/common-auth";
import { platformStatuses as zhStatuses } from "./i18n/features/zh/platform-statuses";
import { sharedCoreZh } from "./i18n/features/zh/shared-core";
import {
  DEFAULT_LOCALE,
  getLocale as sharedGetLocale,
  normalizeLocale,
  setLocale as sharedSetLocale,
  subscribeLocaleChange as sharedSubscribeLocaleChange,
} from "./i18n/locale-state";
import { createI18nRuntime } from "./i18n/runtime";

export type { AppLocale } from "./i18n/locale-state";
export { APP_LOCALE_LABELS, APP_LOCALES, DEFAULT_LOCALE, normalizeLocale } from "./i18n/locale-state";

const localeCatalogs = {
  "zh-CN": { common: { auth: zhAuth }, platform: { shared: sharedCoreZh, statuses: zhStatuses } },
  en: { common: { auth: enAuth }, platform: { shared: sharedCoreEn, statuses: enStatuses } },
  ja: { common: { auth: jaAuth }, platform: { shared: sharedCoreJa, statuses: jaStatuses } },
} as const;

export const zhCN = localeCatalogs["zh-CN"];
export type Messages = typeof zhCN;

export const {
  messageCatalogs,
  setLocale,
  getLocale,
  subscribeLocaleChange,
  createMessageProxy,
  hasMessage,
  t,
  formatMessage,
  formatEnumPath,
  formatEnumLabel,
  formatBooleanLabel,
  formatLocalizedList,
  formatActionObjectLabel,
  formatActionObjectMessage,
  formatActionObjectIntlLabel,
} = createI18nRuntime({
  defaultLocale: DEFAULT_LOCALE,
  localeCatalogs,
  normalizeLocale,
  localeState: {
    getLocale: sharedGetLocale,
    setLocale: sharedSetLocale,
    subscribeLocaleChange: sharedSubscribeLocaleChange,
  },
});

export type {
  DeepPartialMessageTree,
  FormatMessageLike,
  MessageDescriptor,
  MessageParams,
  MessageTree,
} from "./i18n/runtime";
